








import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'
import UiLogout from '@/components/ui/ui-logout.vue';


@Component({
  components: {
    Card,
    UiLogout,
  }
})
export default class StorybookLogout extends Vue {
  beforeLogout() {
    console.log('Action before logout')
  }
}
